import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";

export const useFanFollowerBeingFollowedFeedStore = defineSmartFeedPiniaStore("fan-follower-being-followed-feed-store", {
  state: () => ({
    visibility: 1,
    smartFeedEngine: new SmartFeedEngine(),
    orgIdFollowing: null,
    metadata: {
      lastId: 0,
      hasMore: false,
      orgIdFollowing: 0, // this will be fetched from another store
    },
  }),
  getters: {
    feedUrl() {
      let orgIdFollowing = this.metadata.orgIdFollowing;

      if (this.orgIdFollowing) {
        orgIdFollowing = this.orgIdFollowing;
      }

      return `org/followed/${orgIdFollowing}/smart-feed`;
    },
    smartFeedRequestGetParams() {
      return {
        last_id: this.metadata.lastId,
        visibility: this.visibility,
      };
    },
  },
});
